import NestedForm from '@stimulus-components/rails-nested-form'

export default class extends NestedForm {
  static targets = ['counter', 'removeButton', 'addButton']
  static values = {
    min: { type: Number, default: 0 },
    max: Number
  }

  connect() {
    super.connect()
    this.refreshCounters()
    this.updateRemoveButtons()
    this.updateAddButton()
  }

  add(event) {
    event.preventDefault()

    if (this.hasMaxValue) {
      const count = this.countVisible()
      if (count >= this.maxValue) {
        return
      }
    }

    const target = this.element.querySelector('[data-limited-nested-form-target="target"]')
    const template = this.element.querySelector('[data-limited-nested-form-target="template"]')

    if (!target || !template) return

    const content = template.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    target.insertAdjacentHTML('beforeend', content)

    this.refreshCounters()
    this.updateRemoveButtons()
    this.updateAddButton()
  }

  remove(event) {
    if (this.minValue > 0) {
      const count = this.countVisible()
      if (count <= this.minValue) {
        event.preventDefault()
        return
      }
    }
    super.remove(event)
    this.refreshCounters()
    this.updateRemoveButtons()
    this.updateAddButton()
  }

  refreshCounters() {
    this.counterTargets.filter((counter) => {
      const wrapper = counter.closest(this.wrapperSelectorValue)
      if (!wrapper) return false
      const destroyInput = wrapper.querySelector('input[name*=\'_destroy\']')
      return !destroyInput || destroyInput.value === '' || destroyInput.value === '0' || destroyInput.value === 'false'
    }).forEach((counter, i) => {
      counter.textContent = `${counter.dataset.counterText} ${i + 1}`
    })
  }

  countVisible() {
    const wrappers = this.element.querySelectorAll(this.wrapperSelectorValue)
    return Array.from(wrappers).filter(w => {
      const destroyInput = w.querySelector('input[name*="_destroy"]')
      return !destroyInput || destroyInput.value === '' || destroyInput.value === '0' || destroyInput.value === 'false'
    }).length
  }

  updateRemoveButtons() {
    const count = this.countVisible()
    const shouldHide = this.minValue > 0 && count <= this.minValue

    this.removeButtonTargets.forEach(button => {
      const wrapper = button.closest(this.wrapperSelectorValue)
      if (!wrapper) return

      const destroyInput = wrapper.querySelector('input[name*="_destroy"]')
      const isVisible = !destroyInput ||
        destroyInput.value === '' ||
        destroyInput.value === '0' ||
        destroyInput.value === 'false'

      if (isVisible) {
        button.style.display = shouldHide ? 'none' : ''
      }
    })
  }

  updateAddButton() {
    if (!this.hasAddButtonTarget) return

    const count = this.countVisible()
    const shouldHide = this.hasMaxValue && count >= this.maxValue

    this.addButtonTarget.style.display = shouldHide ? 'none' : 'flex'
  }
}
